import * as React from 'react';
import './NieuwsBriefSwitch.css';

export default (props: {nieuwsbrief: boolean, setNieuwsbrief: (n: boolean) => void}) => (
    <div className='row' style={{alignItems: 'center'}}>
        <span className={`smallText nieuwsbriefDingie ${props.nieuwsbrief ? 'dingieActive' : ''}`} onClick={() => props.setNieuwsbrief(true)}>Ja</span>
        <span className={`smallText nieuwsbriefDingie ${!props.nieuwsbrief ? 'dingieActive' : ''}`}onClick={() => props.setNieuwsbrief(false)}>Nee</span>
    </div>
)